import { CoinAddedByEnum, ProductsEnum } from '@/enums';
import { IUserTransaction } from '@/interfaces';
import ButtonLinkUser from '../ButtonLinkUser';
import { Badge } from '@/components/ui';

type TProps = {
  transaction: IUserTransaction;
}

export const DataTableBodyCellDetailsPaidCoins = ({ transaction }: TProps) => {

  if (transaction?.product !== ProductsEnum.PAID_COINS) {
    return <></>;
  }

  return (
    <div className='flex items-center space-x-1 text-sm text-nowrap'>
      {
        transaction.options?.packageName &&
        <>
          <span>
            Package
          </span>
          <Badge
            variant={'secondary'}
            className='text-xs'>
            {transaction.options.packageName}
          </Badge>
        </>
      }
      {
        transaction.options?.coinsAddedBy === CoinAddedByEnum.MANUALLY &&
        transaction.options.adminUserId &&
        <>
          <span>
            Ajouté par
          </span>
          <ButtonLinkUser userId={transaction.options.adminUserId} />
          <span className='text-muted-foreground'>
            •
          </span>
          <span className='text-muted-foreground'>
            {transaction.options.comment}
          </span>
        </>
      }
    </div>
  );

}

export default DataTableBodyCellDetailsPaidCoins;
